import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["dropdown", "confirmIcon"]

  static values = {
    accountId: String,
    updateUrl: String,
    currentPurpose: String,
    confirmed: Boolean,
  }

  declare readonly dropdownTarget: HTMLSelectElement
  declare readonly hasDropdownTarget: boolean
  declare readonly confirmIconTarget: HTMLElement
  declare readonly hasConfirmIconTarget: boolean
  declare accountIdValue: string
  declare updateUrlValue: string
  declare currentPurposeValue: string
  declare confirmedValue: boolean

  async selectPurpose(event: Event) {
    const purposeKey = (event.target as HTMLSelectElement).value
    const csrfToken = document.querySelector<HTMLMetaElement>('meta[name="csrf-token"]')!.content

    if (!purposeKey) {
      await this.removePurpose()
      return
    }

    try {
      const response = await fetch(this.updateUrlValue, {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
          "X-CSRF-Token": csrfToken,
          Accept: "application/json",
        },
        body: JSON.stringify({ purpose_key: purposeKey }),
      })

      const data = await response.json()

      if (response.ok) {
        this.currentPurposeValue = purposeKey
        this.confirmedValue = true
        this.showConfirmIcon()
        this.showSuccessIndicator()
      } else {
        this.showError(data.errors ? data.errors.join(", ") : "Failed to assign purpose")
        // Revert selection
        this.dropdownTarget.value = this.currentPurposeValue || ""
      }
    } catch (error) {
      this.showError("Failed to assign purpose")
      this.dropdownTarget.value = this.currentPurposeValue || ""
    }
  }

  async removePurpose() {
    const csrfToken = document.querySelector<HTMLMetaElement>('meta[name="csrf-token"]')!.content

    try {
      const response = await fetch(this.updateUrlValue, {
        method: "DELETE",
        headers: {
          "X-CSRF-Token": csrfToken,
          Accept: "application/json",
        },
      })

      if (response.ok) {
        this.currentPurposeValue = ""
        this.confirmedValue = false
        this.hideConfirmIcon()
      } else {
        // Revert selection
        this.dropdownTarget.value = this.currentPurposeValue || ""
      }
    } catch (error) {
      this.showError("Failed to remove purpose")
      this.dropdownTarget.value = this.currentPurposeValue || ""
    }
  }

  showConfirmIcon() {
    if (this.hasConfirmIconTarget) {
      this.confirmIconTarget.classList.remove("hidden")
    }
  }

  hideConfirmIcon() {
    if (this.hasConfirmIconTarget) {
      this.confirmIconTarget.classList.add("hidden")
    }
  }

  showSuccessIndicator() {
    if (this.hasDropdownTarget) {
      this.dropdownTarget.classList.add("ring-2", "ring-green-500")
      setTimeout(() => {
        this.dropdownTarget.classList.remove("ring-2", "ring-green-500")
      }, 1000)
    }
  }

  showError(message: string) {
    console.error(message)
    // Could integrate with a toast/notification system
    alert(message)
  }
}
